<template>
  <Page class="page-container--wide page-container--scrollable-table">
    <PageContent>
      <div class="activity-log-grid">
        <ActivityLogDateRangePicker />
        <ActivityLogTabs />
      </div>
      <RouterView />
    </PageContent>
  </Page>
</template>

<script lang="ts" setup>
import { useAccountMembershipsContext } from '@/composables/deepadmin/use-account-memberships-context.ts'
import { useActivityLogAccess } from '@/composables/deepadmin/use-activity-log-access.ts'
import { createActivityLogTabsContext } from '@/composables/deepadmin/use-activity-log-tabs-context.ts'
import usePageAccess from '@/composables/deepadmin/use-page-access.ts'
import ActivityLogDateRangePicker from '@/components/deepadmin/activity-log/ActivityLogDateRangePicker.vue'
import ActivityLogTabs from '@/components/deepadmin/activity-log/ActivityLogTabs.vue'
import Page from '@/components/page/Page.vue'
import PageContent from '@/components/page/PageContent.vue'

definePage({
  meta: {
    breadcrumbLabelKey: 'navigation.organization.activity_log.title',
  },
})

const { selectedOrganizationId } = useAccountMembershipsContext()
const { showAny } = useActivityLogAccess()

createActivityLogTabsContext(selectedOrganizationId)

usePageAccess(computed(() => !showAny.value))
</script>

<style scoped lang="scss">
@use 'sass:map';
@use 'vuetify/lib/styles/settings/variables' as *;

// Columns that both rows below align to via grid-template-columns: subgrid
.activity-log-grid {
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: 16px;
  margin-bottom: 16px;

  @media #{map.get($display-breakpoints, 'md-and-up')} {
    // 32px columns are dedicated gaps (grid gap is 0); rows without content there skip via explicit grid-column
    grid-template-columns: 360px 32px 240px 32px 240px;
  }
}
</style>
